"use client";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as y } from "./tv.config-BuYIgndg.mjs";
import { useButtonGroupContext as w } from "./ButtonGroupContext.js";
import { u as N } from "./useRender-DCcXqLqs.mjs";
import { L as k } from "./loader-circle-CSITy8jU.mjs";
import { m as T } from "./useRenderElement-B8V3_e8R.mjs";
const j = y({
  base: [
    "Button_root",
    "rounded-xl",
    "border",
    "border-2",
    "ease-linear",
    "transition-all",
    "duration-150",
    "disabled:bg-slate-200",
    "disabled:text-slate-500",
    "disabled:border-slate-200",
    "focus-visible:ring-2",
    "outline-0",
    "inline-flex",
    "items-center",
    "justify-center",
    "appearance-none",
    "whitespace-nowrap",
    "gap-2",
    "capitalize"
  ],
  variants: {
    color: {
      default: [
        "bg-white",
        "border-white",
        "hover:border-white",
        "hover:bg-white",
        "text-gray-900"
      ],
      primary: [
        "bg-primary-main",
        "border-primary-main",
        "hover:border-primary-dark",
        "hover:bg-primary-dark",
        "focus-visible:ring-primary-light",
        "text-primary-contrastText"
      ],
      secondary: [
        "bg-secondary-main",
        "border-secondary-main",
        "hover:bg-secondary-dark",
        "hover:border-secondary-dark",
        "focus-visible:ring-secondary-light",
        "text-secondary-contrastText"
      ],
      success: [
        "bg-success-main",
        "border-success-main",
        "hover:bg-success-dark",
        "hover:border-success-dark",
        "focus-visible:ring-success-light",
        "text-success-contrastText"
      ],
      warning: [
        "bg-warning-main",
        "border-warning-main",
        "hover:bg-warning-dark",
        "hover:border-warning-dark",
        "focus-visible:ring-warning-light",
        "text-warning-contrastText"
      ],
      info: [
        "bg-info-main",
        "border-info-main",
        "hover:bg-info-dark",
        "hover:border-info-dark",
        "focus-visible:ring-info-light",
        "text-info-contrastText"
      ],
      error: [
        "bg-error-main",
        "border-error-main",
        "hover:bg-error-dark",
        "hover:border-error-dark",
        "focus-visible:ring-error-light",
        "text-error-contrastText"
      ],
      gray: [
        "bg-indigo-100",
        "border-indigo-100",
        "hover:bg-indigo-200",
        "hover:border-indigo-200",
        "focus-visible:ring-indigo-200",
        "text-black"
      ]
    },
    size: {
      small: ["text-xs", "h-8", "px-3"],
      medium: ["text-sm", "h-10", "px-4"],
      large: ["text-base", "h-12", "px-5"]
    },
    variant: {
      contained: ["focus-visible:ring-2"],
      outlined: ["bg-transparent", "focus-visible:ring-2"],
      text: [
        "bg-transparent",
        "border-transparent",
        "hover:bg-transparent",
        "hover:border-transparent",
        "focus-visible:ring-transparent"
      ]
    },
    fullWidth: {
      true: ["w-full", "justify-center", "flex"]
    },
    roundedFull: {
      true: ["!rounded-full"]
    },
    hasIcon: {
      true: ["inline-flex", "flex-shrink-0", "items-center"]
    },
    onlyIcon: {
      true: ["w-10", "!px-0"]
    }
  },
  compoundVariants: [
    {
      variant: "outlined",
      color: "default",
      className: ["text-white", "hover:text-white", "!bg-transparent"]
    },
    {
      variant: "outlined",
      color: "primary",
      className: ["text-primary-main", "hover:text-primary-contrastText"]
    },
    {
      variant: "outlined",
      color: "secondary",
      className: ["text-secondary-main", "hover:text-secondary-contrastText"]
    },
    {
      variant: "outlined",
      color: "success",
      className: ["text-success-main", "hover:text-success-contrastText"]
    },
    {
      variant: "outlined",
      color: "warning",
      className: ["text-warning-main", "hover:text-warning-contrastText"]
    },
    {
      variant: "outlined",
      color: "error",
      className: ["text-error-main", "hover:text-error-contrastText"]
    },
    {
      variant: "outlined",
      color: "info",
      className: ["text-info-main", "hover:text-info-contrastText"]
    },
    {
      variant: "text",
      color: "primary",
      className: ["text-primary-main"]
    },
    {
      variant: "text",
      color: "secondary",
      className: ["text-secondary-main"]
    },
    {
      variant: "text",
      color: "success",
      className: ["text-success-main"]
    },
    {
      variant: "text",
      color: "warning",
      className: ["text-warning-main"]
    },
    {
      variant: "text",
      color: "error",
      className: ["text-error-main"]
    },
    {
      variant: "text",
      color: "info",
      className: ["text-info-main"]
    }
  ],
  defaultVariants: {
    variant: "contained",
    color: "default",
    size: "medium"
  }
}), P = (c) => {
  const {
    render: d,
    color: m,
    label: x,
    fullWidth: g,
    variant: u,
    roundedFull: b,
    size: v,
    className: h,
    startIcon: a,
    endIcon: t,
    icon: n,
    children: o,
    href: i,
    loading: s,
    ...l
  } = c, r = w(), f = i ? /* @__PURE__ */ e.jsx("a", {}) : d ?? /* @__PURE__ */ e.jsx("button", {}), p = {
    ...i ? { href: i } : { type: "button", disabled: s || l.disabled },
    children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      !!(a || s) && /* @__PURE__ */ e.jsx("span", { children: s ? /* @__PURE__ */ e.jsx(k, { className: "animate-spin" }) : a }),
      n || o || x,
      !!t && /* @__PURE__ */ e.jsx("span", { children: t })
    ] }),
    className: j({
      color: m || (r == null ? void 0 : r.color),
      variant: u || (r == null ? void 0 : r.variant),
      fullWidth: g || (r == null ? void 0 : r.fullWidth),
      roundedFull: b,
      size: v || (r == null ? void 0 : r.size),
      class: h,
      hasIcon: !!a || !!t,
      onlyIcon: !!n && !o
    })
  };
  return N({
    render: f,
    props: T(p, l)
  });
};
export {
  P as default
};
